<template>
  <div style="margin-top: 5px">
    <b-container style="background-color: #f5f5f0">
      <div class="card" >
        <div style="background-color:#ffdb4d">
        <div class="card-title pt-4" style="text-align: left">
          <b-row>
            <b-col cols="12" md="1"></b-col>
            <b-col cols="12" md="5">
              <h4>
                <span
                  style="
                    color: black;
                    font-weight: 600;
                    font-size: 20px;
                    text-align: justify;
                  "
                >
                  Thomas Varughese
                </span>
              </h4>
            </b-col>
          </b-row>
        </div>
        <b-row class="text-center">
          <b-col>
            <b-row>
              <b-col></b-col>
              <b-col cols="12" md="2">
                <b-row>
                  <b-col cols="12" class="py-1"
                    ><img
                      src="../assets/thomas.jpg"
                      height="150px"
                      width="150px"
                      contain
                    />
                  </b-col>
                </b-row>
              </b-col>

              <b-col cols="12" md="4">
                <h6
                  style="
                    color: black;
                   
                    font-size: 15px;
                    text-align: justify;
                  "
                >
                  Thomas is an Asst. Professor in Information Technology at Amal
                  Jyothi College of Engineering and a bee keeper with more than
                  20 years of experience.He maintains a medium size apiary and
                  sells honey, bee boxes and colonies. He’s happy enough to talk
                  about the bees he kept in his back garden, to explore the
                  changing symbolism of the hive throughout the ages. Although
                  he lives quite a professional life, he always finds time where
                  he could spend a couple of hours opening hives.
                </h6>
              </b-col>
              <b-col
                style="color: black; font-size: 15px; text-align: justify"
                cols="12"
                md="4"
              >
                <b-row>
                  <b-col cols="12" md="5">Phone:</b-col>
                  <b-col cols="12" md="7">+91 9446264778</b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" md="5">E-mail:</b-col>
                  <b-col cols="12" md="7">thomasv.mahe@gmail.com</b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" md="5">Address:</b-col>
                  <b-col cols="12" md="7"
                    >Valiyakulathil(H),&nbsp;Kovapally&nbsp;P.O, Palambra,
                    Kanjirapally, Kottayam</b-col
                  >
                </b-row>
                <b-row>
                  <b-col cols="12" md="5">Honey available:</b-col>
                  <b-col cols="12" md="7">11 Kg</b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" md="5">Price / Kg:</b-col>
                  <b-col cols="12" md="7">Rs. 350</b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" md="5">Sell online(Y/N):</b-col>
                  <b-col cols="12" md="7">Yes</b-col>
                </b-row>
                <br />
                <div class="pr-2" style="text-align: right">
                  <b-button variant="success" style=" width: 100px"
                    >Buy Now</b-button
                  >
                  
                </div>
              </b-col>
              <b-col></b-col>
            </b-row>
          </b-col>
        </b-row>
        <br>
          </div> 
        <section>
          <br /><br />
          <div class="row mx-4">
            <div class="col-12 grid-margin">
              <div class="card">
                <div class="card-body">
                  <!-- <h4 class="card-title">
                {{ userData.firstname }} {{ userData.lastname }} &nbsp;
                <router-link :to="'/sightingsloc1/' + this.id">
                <span>
                  <i style="color: red !important" class="fa fa-map-marker"></i>
                </span>
              </router-link>
              </h4> -->

                  <!-- <div class="row pt-4">
                <div class="col-md-2" style="justify-content: center">
                  <div style="justify-content: center" class="row">
                    <output>
                      <img
                        :src="image"
                        v-if="userData.photo"
                        style="width: 150px; height: 150px"
                      />
                      <p v-else>No image...</p>
                      <router-link :to="'/editmyprofile/'+this.userid"> <span class="flex md12 " align="right"><i class="fa fa-pencil"></i></span></router-link>
                    </output>
                  </div>
                </div>
                <div class="col-md-5" style="justify-content: center">
                  <h6 style="text-align: justify">
                    Thomas is an Asst. Professor in Information Technology at
                    Amal Jyothi College of Engineering and a bee keeper with
                    more than 20 years of experience.He maintains a medium size
                    apiary and sells honey, bee boxes and colonies.
                  </h6>
                </div>
                <div class="col-md-5" style="justify-content: center">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-4">Email</div>
                      <div class="col-md-6">{{ userData.email }}</div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">Phone</div>
                      <div class="col-md-6">{{ userData.phone }}</div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">Addess</div>
                      <div class="col-md-6">
                        Valiyakulathil (H),Koovappally p.o,<br />
                        Palambra, Kanjirappally, Kottayam
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">Honey Available</div>
                      <div class="col-md-6">11 kg</div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">Price/kg</div>
                      <div class="col-md-6">Rs. 350</div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">Sell Online</div>
                      <div class="col-md-6">Yes</div>
                    </div>
                  </div>
                </div>
              </div> -->

                  <div class="pt-2">
                    <div class="pt-2s" style="text-align: left">
                      <span style="font-weight: 600">COLONIES</span>
                    </div>

                    <div class="pt-4" id="myMap"></div>

                    <!-- <b-tab @click="getWarnings('Examination')" title="Examination">
                  <div class="pt-4" id="myMap3"></div>
                </b-tab> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </b-container>
  </div>
</template>
 <script>
import axios from "axios";
var marker;

export default {
  name: "myprofile",
  props: ["id"],
  components: {},
  data() {
    return {
      appLoading: false,
      tabIndex: null,
      userData: [],
      image: null,
      event: "Examination",
      colonies: [],
      data: [],
      warnings: [],
      late: [],
      normal: [],

      events: [
        {
          title: "Examination",
          value: "Examination",
        },
        {
          title: "Diseases / Treatments / Pests",
          value: "Diseases",
        },
        {
          title: "Honey Harvesting",
          value: "Honey Collection",
        },
        {
          title: "Feeding",
          value: "Feeding",
        },
        {
          title: "Queen Replacement",
          value: "Queen Replacement",
        },
        {
          title: "Reset Colony",
          value: "Reset Colony",
        },
        {
          title: "Division",
          value: "Division",
        },
      ],
    };
  },
  mounted: function () {
    this.getColonyList();

    //this.getEventList();
    //this.getColonyList();
  },
  watch: {
    // event() {
    //   this.getWarnings();
    // },
  },
  methods: {
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ["bg-primary", "text-light"];
      } else {
        return ["bg-light", "text-info"];
      }
    },
    getColonyList() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/colony/admingetlisttemp",

        params: {
          userid: "5f8ea4f80b5192aae769f667",
        },
      })
        .then((response) => {
          this.appLoading = false;

          if (response.data.status === true) {
            this.colonies = response.data.data;
            this.data = response.data.data;
            var mapCanvas = document.getElementById("myMap");

            var mapOptions = {
              center: new google.maps.LatLng(
                this.data[0].location[1],
                this.data[0].location[0]
              ),
              zoom: 18,

              mapTypeId: google.maps.MapTypeId.TERRAIN,
            };
            var vm = this;

            vm.map = new google.maps.Map(mapCanvas, mapOptions);

            // var data = {};

            for (var i = 0; i < this.data.length; i++) {
              var lat = this.data[i].location[1];
              var lon = this.data[i].location[0];
              var latlngset = new google.maps.LatLng(lat, lon);
              if (this.data[i].colonystatus == "Excellent") {
                var icon = {
                  url:
                    "http://arhiveadmin.leopardtechlabs.com/img/greenmarker.png", // url
                  scaledSize: new google.maps.Size(20, 32), // scaled size
                  origin: new google.maps.Point(0, 0), // origin
                  anchor: new google.maps.Point(0, 0), // anchor
                };
              } else if (this.data[i].colonystatus == "Good") {
                var icon = {
                  url:
                    "http://arhiveadmin.leopardtechlabs.com/img/orangemarker.png", // url
                  scaledSize: new google.maps.Size(20, 32), // scaled size
                  origin: new google.maps.Point(0, 0), // origin
                  anchor: new google.maps.Point(0, 0), // anchor
                };
              } else if (this.data[i].colonystatus == "OK") {
                var icon = {
                  url:
                    "http://arhiveadmin.leopardtechlabs.com/img/yellowmarker.png", // url
                  scaledSize: new google.maps.Size(20, 32), // scaled size
                  origin: new google.maps.Point(0, 0), // origin
                  anchor: new google.maps.Point(0, 0), // anchor
                };
              } else if (this.data[i].colonystatus == "Not ok") {
                var icon = {
                  url:
                    "http://arhiveadmin.leopardtechlabs.com/img/redmarker.png", // url
                  scaledSize: new google.maps.Size(20, 32), // scaled size
                  origin: new google.maps.Point(0, 0), // origin
                  anchor: new google.maps.Point(0, 0), // anchor
                };
              }

              marker = new google.maps.Marker({
                map: vm.map,
                position: latlngset,
                icon: icon,
                // icon: iconBase
              });
              var content =
                '<p>Colony ID: <span style="color:red">' +
                this.data[i].tagid +
                "</span></p>" +
                ' Colony Status: <span style="color:green">' +
                this.data[i].colonystatus +
                "</span></p>";

              var infowindow = new google.maps.InfoWindow();

              google.maps.event.addListener(
                marker,
                "click",
                (function (marker, content, infowindow) {
                  return function () {
                    infowindow.setContent(content);
                    infowindow.open(vm.map, marker);
                  };
                })(marker, content, infowindow)
              );
            }
            //        window.myFunction = function (id) {
            //   vm.$router.push("/colonyDetails/" + id);
            // };
            //   for(var i=0;i<5;i++)
            //  {
            //    this.getEventList(this.colonies[i].colonyidentifier)
            // }
            this.appLoading = false;
          } else if (response.data.status === false) {
            this.appLoading = false;
          }
        })
        .catch((e) => {
          this.appLoading = false;
          //this.errors.push(e);
          this.msg = "failed";
        });
    },
    getWarnings() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/event/adminwarnings",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          user: this.id,
          event: this.event,
        },
      })
        .then((response) => {
          this.appLoading = false;

          if (response.data.status === true) {
            this.warnings = response.data;
            var lateid = 0;
            var mapCanvas = document.getElementById("myMap3");

            var mapOptions = {
              center: new google.maps.LatLng(
                this.warnings.late[0].location[1],
                this.warnings.late[0].location[0]
              ),
              zoom: 14,

              mapTypeId: google.maps.MapTypeId.TERRAIN,
            };
            var vm = this;

            vm.map = new google.maps.Map(mapCanvas, mapOptions);

            // var data = {};

            if (this.warnings.late.length > 0) {
              for (var j = 0; j < this.warnings.late.length; j++) {
                console.log(j, "hiijr");
                var lat = this.warnings.late[j].location[1];
                var lon = this.warnings.late[j].location[0];
                var latlngset = new google.maps.LatLng(lat, lon);
                var icon = {
                  url:
                    "http://arhiveadmin.leopardtechlabs.com/img/yellowmarker.png", // url
                  scaledSize: new google.maps.Size(20, 32), // scaled size
                  origin: new google.maps.Point(0, 0), // origin
                  anchor: new google.maps.Point(0, 0), // anchor
                };
                marker = new google.maps.Marker({
                  map: vm.map,
                  position: latlngset,
                  // markerId:MarkerId(lateid),

                  icon: icon,
                  // icon: iconBase
                });
                //  console.log(latlngset,'hi latingr');

                var content =
                  '<p>Colony ID: <span style="color:red">' +
                  this.warnings.late[j].colonyidentifier +
                  "</span></p>" +
                  ' Colony Status: <span style="color:green">' +
                  this.warnings.late[j].colonystatus +
                  "</span></p>" +
                  '<a href="/colonyDetails/' +
                  this.warnings.late[j]._id +
                  '"><button class="btn btn-success" >View Details</button></a>';

                var infowindow = new google.maps.InfoWindow();

                google.maps.event.addListener(
                  marker,
                  "click",
                  (function (marker, content, infowindow) {
                    return function () {
                      infowindow.setContent(content);
                      infowindow.open(vm.map, marker);
                    };
                  })(marker, content, infowindow)
                );
              }
            }
            console.log("hii");
            if (this.warnings.normal.length > 0) {
              for (var k = 0; k < this.warnings.normal.length; k++) {
                console.log(k, "hiijk");
                var lat = this.warnings.normal[k].location[1];
                var lon = this.warnings.normal[k].location[0];
                var latlngset = new google.maps.LatLng(lat, lon);
                var icon1 = {
                  url:
                    "http://arhiveadmin.leopardtechlabs.com/img/greenmarker.png", // url
                  scaledSize: new google.maps.Size(20, 32), // scaled size
                  origin: new google.maps.Point(0, 0), // origin
                  anchor: new google.maps.Point(0, 0), // anchor
                };
                marker = new google.maps.Marker({
                  map: vm.map,
                  position: latlngset,
                  // markerId:MarkerId(lateid),

                  icon: icon1,
                  // icon: iconBase
                });
                //  console.log(latlngset,'hi latingr');

                var content =
                  '<p>Colony ID: <span style="color:red">' +
                  this.warnings.normal[k].colonyidentifier +
                  "</span></p>" +
                  ' Colony Status: <span style="color:green">' +
                  this.warnings.normal[k].colonystatus +
                  "</span></p>" +
                  '<a href="/colonyDetails/' +
                  this.warnings.normal[k]._id +
                  '"><button class="btn btn-success" >View Details</button></a>';

                var infowindow = new google.maps.InfoWindow();

                google.maps.event.addListener(
                  marker,
                  "click",
                  (function (marker, content, infowindow) {
                    return function () {
                      infowindow.setContent(content);
                      infowindow.open(vm.map, marker);
                    };
                  })(marker, content, infowindow)
                );
              }
            }

            //        window.myFunction = function (id) {
            //   vm.$router.push("/colonyDetails/" + id);
            // };
            //   for(var i=0;i<5;i++)
            //  {
            //    this.getEventList(this.clusters[i].colonyidentifier)
            // }
            this.appLoading = false;
          } else if (response.data.status === false) {
            this.appLoading = false;
          }
        })
        .catch((e) => {
          this.appLoading = false;
          //this.errors.push(e);
          this.msg = "failed";
        });
    },
    myFunction(id) {
      this.$route.push("colonyDetails" + id);
    },

    getview() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/colony/admingetlisttemp",

        params: { id: this.id },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.appLoading = false;
            this.userData = response.data.data;
            this.getColonyList();
            this.getWarnings();

            if (this.userData.photo) {
              this.image = this.baseURL + this.userData.photo;
            }
          } else if (response.data.status === false) {
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.errors.push(err);
          alert("No Network Found!!");
        });
    },
  },
};
</script>
<style>
.circular--square {
  border-top-left-radius: 50% 50%;
  border-top-right-radius: 50% 50%;
  border-bottom-right-radius: 50% 50%;
  border-bottom-left-radius: 50% 50%;
}
#myMap {
  height: 500px !important;
  width: 100%;
}
#myMap2 {
  height: 500px !important;
  width: 100%;
}
#myMap3 {
  height: 500px !important;
  width: 100%;
}
</style>